<div
  class="panel-heading"
  [ngClass]="[isCollapsedChange() ? 'active' : '']"
  [attr.data-testing-id]="dataTestingId()"
  role="tab"
  (click)="toggleCollapse()"
  (keydown.enter)="toggleCollapse()"
  tabindex="0"
>
  <a class="accordion-toggle" [attr.aria-expanded]="isCollapsedChange()">
    {{ heading() }}
    @if (!isCollapsedChange()) {
    <fa-icon class="float-right" [icon]="['fas', 'plus']" />
    } @else {
    <fa-icon class="float-right" [icon]="['fas', 'minus']" />
    }
  </a>
</div>
<div
  class="panel-collapse collapse"
  [ngClass]="[isCollapsedChange() ? 'active' : '']"
  role="tabpanel"
  [ngbCollapse]="!isCollapsedChange()"
>
  <div class="panel-body"><ng-content /></div>
</div>
